import React, { ReactNode } from 'react';
import { User } from '../../../interfaces/backend/User';
import { CodeType } from '../CodeType';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import CodeBlock from '../CodeBlock';
import { readWebsiteVariable } from '../../../utils/readWebsiteVariable';
import { BuildCodeParams } from './CodeSample';

export default class BackendCurlSample extends BackendCodeSample {
  name = 'curl';
  language = 'bash';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = undefined;

  buildCode({
    environment,
    notification,
    user,
    mergeTags
  }: BuildCodeParams): ReactNode {
    const secret = `Basic ${Buffer.from(
      `${environment.clientId}:${environment.clientSecret}`
    ).toString('base64')}`;

    const code = `curl 'https://${readWebsiteVariable(
      'REACT_APP_api_domain'
    )}/${environment.clientId}/sender' \\
-H 'authorization: ${secret}' \\
-H 'content-type: application/json' \\
--data-raw \\
  '{
    "notificationId": "${notification.notificationId}",
    "user": {
      ${this.buildUserObjectString(user, '\n      ')}
    },
    "mergeTags": ${JSON.stringify(mergeTags, null, 6).slice(0, -1) + '    }'}
  }'`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          Paste the following code into your terminal to send your first
          notification:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `"id": "${user.id}"`,
      email: `"email": "${user.email}"`,
      number: `"number": "${user.number}"`
    };
  }
}
